export const HIDE_BOTTOM_SERVICE_MODE_ROUTES: string[] = [];
